import { Col, Card, Button, Form } from "react-bootstrap";
import "../styles/form.css";
import { useState } from "react";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";

/**
 *
 * @param {string} formType "Duális képzés" | "Pályázat" | "Hitel" | "Bankszámla"
 */
export default function FormSection({ formType }) {
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState("idle");
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    setStatus("loading");

    try {
      const formData = new FormData(form);

      if (formType) {
        formData.append("formType", formType);
      }

      const response = await fetch("/php/send.php", {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        setStatus("success");
        navigate("/koszonjuk", { state: { formType } });
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <Container id="ajanlat" className="d-flex justify-content-center p-0">
      <Card className="card form-card px-4 py-2">
        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          style={{ maxWidth: "800px", margin: "auto", textAlign: "center" }}
        >
          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">
              Kapcsolattartó neve
            </Form.Label>
            <Form.Control
              name="contact"
              placeholder="pl.: Minta János"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek add meg a kapcsolattartó nevét.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Telefonszám</Form.Label>
            <Form.Control
              name="phone"
              placeholder="pl.: +36 20 123 4567"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek adj meg egy érvényes telefonszámot.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Email</Form.Label>
            <Form.Control
              name="email"
              type="email"
              placeholder="pl.: mjanos@almafa.hu"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek adj meg egy érvényes email címet.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="text-left p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Cégnév</Form.Label>
            <Form.Control
              name="company"
              placeholder="pl.: Almafa Kft"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek add meg a céged nevét.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Kérdés</Form.Label>
            <Form.Control
              name="message"
              as="textarea"
              placeholder="pl.: Milyen támogatásra jogosult a cégem?"
            />
          </Form.Group>

          <Col xs={12} className="d-flex justify-content-center my-3">
            <Button
              className="btn btn-primary"
              type="submit"
              disabled={status === "loading" || status === "success"}
            >
              {status === "loading"
                ? "Küldés..."
                : status === "success"
                ? "Sikeres beküldés"
                : status === "error"
                ? "Sikertelen beküldés"
                : "Visszahívást kérek"}
            </Button>
          </Col>
          {status === "error" && (
            <Col xs={12}>
              <p className="text-danger mb-0">
                Kérjük írj emailt nekünk:
                <br />
                <strong>financials@financials.hu</strong>
              </p>
            </Col>
          )}
          <div className="small" style={{ textAlign: "left" }}>
            Az űrlap elküldésével elfogadod az{" "}
            <a className="form-section-a" href="/adatkezelesi-tajekoztato">
              adatkezelési tájékoztatóban
            </a>{" "}
            foglaltakat.
          </div>
        </Form>
      </Card>
    </Container>
  );
}
